import { findProjectListByUser, getProjects } from '@/api/project/project';
import './header.less'
import { ReactComponent as BIMSvg } from '@/commons/icons/top/bim.svg';
import { ReactComponent as BlackDownSvg } from '@/commons/icons/top/black-arrow.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { Project } from '@/commons/interface/project/project';
import { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { ContextMenuWrapper } from 'tncet-common';
import CreateProjectModal from '@/layout/desktop/create-project-modal';
import { ReactComponent as AddSvg } from './icons/add-green.svg';
import { UserFeedbackActiveBtn } from '@/commons/components/user-feedback';
import { SystemContext } from '@/App';
import { SystemStatus } from '@/commons/context/system-store';
import { USER_TYPE } from '@/commons/enums/user';
import localStore from '@/commons/store/local-store';

export interface IProps {
    feedbackVisible: boolean,
    changeFeedbackVisible: (value: boolean) => void
}

export default function ProjectHeader(props: IProps) {

    const { feedbackVisible, changeFeedbackVisible } = props;
    const systemContext = useContext<SystemStatus>(SystemContext);
    const navigate = useNavigate();
    const { projectUuid } = useParams();
    const [projects, setProjects] = useState<Project[]>([]); // 项目
    const [project, setProject] = useState<Project>(null);
    const [showExpand, setShowExpand] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);

    // 初始化数据
    useEffect(() => {
        generateData();
    }, [])

    // 获取数据
    const generateData = () => {
        findProjectListByUser().then(res => {
            let data: Project[] = res.data || [];
            setProjects(data);
        })
    }

    // 监听项目变化
    useEffect(() => {
        if (!projectUuid) {
            setProject(null);
            return;
        }
        let curProj: Project = projects?.find(item => item.uuid === projectUuid);
        setProject(curProj);
    }, [projectUuid, projects])

    // 切换项目
    const projectClick = (item: Project) => {
        navigate(`/project/${item.uuid}`)
        setShowExpand(false);
    }

    return (
        <div className="project-header-container">
            <div className='top-logo'>
                <BIMSvg onClick={() => { navigate(`/desktop`) }} />
            </div>
            {localStore?.getUser() && (
                <>
                    <ContextMenuWrapper
                        visible={showExpand}
                        closable={true}
                        onVisibleChange={(visible: boolean) => {
                            setShowExpand(visible);
                        }}
                        width={243}
                        container={
                            <div className='project-panel'>
                                <div className='project-name'>{project?.name || ''}</div>
                                <div className='project-arrow'>
                                    {showExpand && <BlackDownSvg />}
                                    {!showExpand && <BlackDownSvg />}
                                </div>
                            </div>
                        }
                        wrapperClassname='project-dropdown-panel'
                    >
                        <div className='project-dropdown-scroll-area'>
                            {projects?.map(item => (
                                <div
                                    className={classNames({
                                        'project-dropdown-item': true,
                                        'project-dropdown-item-active': item?.uuid === projectUuid,
                                    })}
                                    key={item.id}
                                    onClick={() => projectClick(item)}
                                >{item?.name || ''}</div>
                            ))}
                        </div>
                    </ContextMenuWrapper>
                    <div className='add-panel' onClick={() => setShowModal(true)}><AddSvg /></div>
                    <div className='header-right'>
                        <UserFeedbackActiveBtn visible={feedbackVisible} changeVisible={(value) => changeFeedbackVisible(value)} />
                    </div>
                </>
            )}

            {showModal && <CreateProjectModal
                showModal={showModal}
                setShowModal={setShowModal}
                onSuccess={() => {
                    generateData();
                    setShowModal(false);
                }}
            />}
        </div >
    )
}
